import { render, staticRenderFns } from "./marketData.vue?vue&type=template&id=61acfcda&scoped=true&"
import script from "./marketData.vue?vue&type=script&lang=js&"
export * from "./marketData.vue?vue&type=script&lang=js&"
import style0 from "./marketData.vue?vue&type=style&index=0&id=61acfcda&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61acfcda",
  null
  
)

export default component.exports